import { Button, Group } from '@mantine/core';
import DownloadIcon from '@/icons/download.svg';
import TrashIcon from '@/icons/trash.svg';
import { RunWorkflow } from '@/app/workflows/components/v6/organism/run/RunWorkflow';
import { Workflow } from '@/app/workflows/actions/interfaces';

type AssetGroupActionsProps = {
  onDownload: () => void;
  onDelete: () => void;
  onRun: (workflow: Workflow) => void;
  isRawAssetSelected: boolean;
  isUnprocessableSelected: boolean;
};

export function AssetGroupActions({
  onDownload,
  onDelete,
  onRun,
  isRawAssetSelected,
  isUnprocessableSelected,
}: AssetGroupActionsProps) {
  return (
    <Group justify='flex-end' gap='xs' wrap='wrap' px='xs'>
      <Button variant='default' leftSection={<DownloadIcon />} onClick={onDownload}>
        Download
      </Button>
      <Button variant='default' leftSection={<TrashIcon />} onClick={() => onDelete()}>
        Delete
      </Button>
      <RunWorkflow onRun={onRun} canBeOpened={isRawAssetSelected} isUnprocessableSelected={isUnprocessableSelected} />
    </Group>
  );
}
